import axios from "axios";

const ENV_URL = process.env.REACT_APP_BACKEND_URL;
const bare = (h) => h.replace(/^www\./, "");
// Custom domains are reachable as both example.com and www.example.com; stay same-origin to avoid CORS/redirect failures.
const BASE = bare(new URL(ENV_URL).hostname) === bare(window.location.hostname) ? window.location.origin : ENV_URL;
const API = `${BASE}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export { API };
